import styled from "styled-components";
import { colors, spacing, transitions } from "../../../../../../styles/theme";

export const Row = styled.tr`
  cursor: pointer;
  transition: ${transitions("fast")};

  :hover {
    background-color: ${colors("default.light")};
    transition: ${transitions("fast")};
  }
`;

export const TableCell = styled.td`
  padding: ${spacing("2")} ${spacing("1")};

  border-bottom: 1px solid ${colors("default.base")};

  &:nth-child(2), &:nth-child(3), &:last-child {
    text-align: center;
  }

  &:last-child {
    vertical-align: middle;
  }
`;